import React from 'react';
import { connect } from 'react-redux';
import LinksMerchantHeader from '../links/LinksMerchantHeader';
import {
  handleChangeInstapayForm,
} from '../../actions/InstapayActions';

const InstapayMerchantHeader = (props) => {
  return (
    <LinksMerchantHeader
      {...props}
      isInstapayPayment={true}
      isRAP={props.isRAP}
      onChangeInstapayForm={() => props.handleChangeInstapayForm()}
    />
  );
};

const mapStateToProps = ({ instapayForm, settings, retry }) => ({
  isEditing: settings.isRetrying ? retry.instapayForm.isEditing : instapayForm.isEditing,
  isRAP: settings.isRAP,
});

export default connect(mapStateToProps, {
  handleChangeInstapayForm,
})(InstapayMerchantHeader);



// WEBPACK FOOTER //
// ./src/payments/views/instapay/InstapayMerchantHeader.js